import fillSum from './fill_sum'

export default function fillSumPlus(content = 'asda{Ⓐ}', expression = '|Ⓐ/B=C,Ⓐ=-4;B=3;C=#|') {
  // 取出变量映射数据
  let [variMapData, pattern] = fillSum(expression, false, true),
  newCte = content
  
  for(let key in variMapData) {
    let val = variMapData[key]
    
    if(newCte.indexOf(`{${key}}`) > -1) {
      newCte = newCte.replaceAll(`{${key}}`, val.value)
    }
  }

  return {newCte, pattern}
}